// extracted by mini-css-extract-plugin
export var blurBox = "notification-module--blur-box--CnEJl";
export var button = "notification-module--button--SV+Te";
export var container = "notification-module--container--kvCnh";
export var contentBox = "notification-module--content-box--dddZs";
export var contentText = "notification-module--content-text--Co61F";
export var date = "notification-module--date--2-oFT";
export var icon = "notification-module--icon--c9DGh";
export var read = "notification-module--read--Doi4X";
export var titleText = "notification-module--title-text--CuRJv";